import { useEffect, useMemo } from 'react';

import * as Sentry from '@sentry/nextjs';

import { GemLackPopupModuleType, StarterPackagePopupPage } from 'src/types/gemLack';
import { Nullable } from 'src/types/utils';

const useParseStarterPackagePopup = (
  starterPackagePopupPage: Nullable<StarterPackagePopupPage>
) => {
  const { singleProductModule, starterPackageModule, refundPolicyModule } = useMemo(() => {
    if (!starterPackagePopupPage) return {};

    const productsSection = starterPackagePopupPage.sections.find(
      (section) => section.sectionType === 'PACKAGE_POPUP_PRODUCTS_B'
    );
    const footerSection = starterPackagePopupPage.sections.find(
      (section) => section.sectionType === 'FOOTER'
    );

    if (!productsSection || !footerSection) return {};

    const singleProduct = productsSection.modules.find(
      (module) => module.moduleType === GemLackPopupModuleType.SINGLE_PRODUCT
    );
    const starterPackage = productsSection.modules.find(
      (module) => module.moduleType === GemLackPopupModuleType.STARTER_PACKAGE_PRODUCT
    );

    const refundPolicy = footerSection.modules?.find(
      (module) => module.moduleType === GemLackPopupModuleType.REFUND_POLICY
    );

    return {
      singleProductModule: singleProduct,
      starterPackageModule: starterPackage,
      refundPolicyModule: refundPolicy,
    };
  }, [starterPackagePopupPage]);

  useEffect(() => {
    if (!starterPackagePopupPage) return;

    if (!singleProductModule || !starterPackageModule) {
      Sentry.captureMessage('Invalid Starter Package Popup DTO', {
        extra: {
          starterPackagePopupPage,
        },
      });
    }
  }, [starterPackagePopupPage, singleProductModule, starterPackageModule]);

  return {
    singleProductModule,
    starterPackageModule,
    refundPolicyModule,
  };
};

export default useParseStarterPackagePopup;
